import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const DateSkeleton = () => (
  <ContentLoader
    width={640}
    height={80}
    uniqueKey="conversation-skeleton-date"
    viewBox="0 0 640 80"
    {...DEFAULT_SETTINGS}>
    <rect x="260" y="30" rx="10" ry="10" width="120" height="20" />
  </ContentLoader>
);
